import { RightAction } from "../../types";


/**
 * Convierte el atributo 'custom-options' (string) a RightAction[].
 * Espera JSON válido. Si falla, retorna [] y loguea error.
 */
export const customOptionsConverter = {
  fromAttribute: (value: string | null): RightAction[] => {
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? (parsed as RightAction[]) : [];
    } catch {
      console.error('[mega-menu] custom-options debe ser JSON válido de array.');
      return [];
    }
  },
  // No reflejamos el array al atributo
  toAttribute: () => null
} as const;
